import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';
import { OrderConfirmDialogTestComponent } from '../../order-confirm-dialog-test/order-confirm-dialog-test.component';
import { PreYoutubeModalComponent } from '../pre-purchase-notice/pre-youtube-modal/pre-youtube-modal.component';
import { PreYoutubeThreeMonthModalComponent } from '../pre-purchase-notice/pre-youtube-three-month-modal/pre-youtube-three-month-modal.component';
import { PreNetflixModalComponent } from '../pre-purchase-notice/pre-netflix-modal/pre-netflix-modal.component';

@Component({
  selector: 'app-platform-dialog-test',
  templateUrl: './platform-dialog-test.component.html',
  styleUrls: ['./platform-dialog-test.component.scss'],
})
export class PlatformDialogTestComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<PlatformDialogTestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productApi: ProductApiService,
    private orderApi: OrderApiService,
    private message: MessageService,
    private user: UserService,
    private router: Router,
    private dialog: MatDialog,
  ) {}
  selected: any = null;
  busTypes: any[] = [];
  self: any = null;
  ngOnInit(): void {
    this.getSelf();
    this.find(this.data.id);
  }

  async getSelf() {
    try {
      this.self = await this.user.getSelf();
    } catch (error) {}
  }

  loading = false;

  busTypeList: any[] = [];
  busTypeGroups: any[] = [];
  grouped = false;
  exclusive = false;

  purchase() {
    if (!this.self) {
      this.router.navigateByUrl('/login');
      return;
    }
    if (!this.selected) {
      return;
    }
    if (this.data.name === 'YouTube') {
      if (this.isYoutubeThreeMonthSelected()) {
        this.dialog
          .open(PreYoutubeThreeMonthModalComponent, {
            width: '622px',
            panelClass: 'overflow-dialog',
          })
          .afterClosed()
          .subscribe((r) => {
            if (r) {
              this.dialog.open(OrderConfirmDialogTestComponent, {
                autoFocus: false,
                panelClass: 'app-dialog',
                data: {
                  platform: this.data,
                  bus_type: this.selected,
                  exclusive: this.exclusive,
                  bus_seat_id: 0,
                  pre_sale_tip: this.data.pre_sale_tip,
                  after_sale_tip: this.data.after_sale_tip,
                  display_label: this.display_label,
                },
              });
            }
          });
      } else {
        this.dialog
          .open(PreYoutubeModalComponent, {
            width: '622px',
            panelClass: 'overflow-dialog',
          })
          .afterClosed()
          .subscribe((r) => {
            if (r) {
              this.dialog.open(OrderConfirmDialogTestComponent, {
                autoFocus: false,
                panelClass: 'app-dialog',
                data: {
                  platform: this.data,
                  bus_type: this.selected,
                  exclusive: this.exclusive,
                  bus_seat_id: 0,
                  pre_sale_tip: this.data.pre_sale_tip,
                  after_sale_tip: this.data.after_sale_tip,
                  display_label: this.display_label,
                },
              });
            }
          });
      }
      return;
    } else if (this.data.name === 'Netflix') {
      this.dialog
        .open(PreNetflixModalComponent, {
          width: '464px',
          panelClass: 'overflow-dialog',
        })
        .afterClosed()
        .subscribe((r) => {
          if (r) {
            this.dialog.open(OrderConfirmDialogTestComponent, {
              autoFocus: false,
              panelClass: 'app-dialog',
              data: {
                platform: this.data,
                bus_type: this.selected,
                exclusive: this.exclusive,
                bus_seat_id: 0,
                pre_sale_tip: this.data.pre_sale_tip,
                after_sale_tip: this.data.after_sale_tip,
                display_label: this.display_label,
              },
            });
          }
        });
      return;
    }

    this.dialog.open(OrderConfirmDialogTestComponent, {
      autoFocus: false,
      panelClass: 'app-dialog',
      data: {
        platform: this.data,
        bus_type: this.selected,
        exclusive: this.exclusive,
        bus_seat_id: 0,
        pre_sale_tip: this.data.pre_sale_tip,
        after_sale_tip: this.data.after_sale_tip,
        display_label: this.display_label,
      },
    });
  }

  displays: any[] = [];
  display_label: any[] = [];

  private isYoutubeThreeMonthSelected(): boolean {
    const selectedText = [this.selected?.name]
      .filter((value) => value !== undefined && value !== null)
      .map((value) => String(value))
      .join(' ');

    return /(?:3|三)\s*个?月|(?:3|三)\s*個?月|Season/i.test(selectedText);
  }

  selectedIndices: { [key: number]: number } = {};

  // 默认选中每一层的第一项
  initSelect(list: any[], level: number) {
    if (!list || list.length === 0) return;

    const first = list[0]; // 取第一项
    this.selectedIndices[level] = 0; // 记录选中状态

    if (first.items) {
      this.totalList(first.items, level + 1, 0);
      this.initSelect(first.items, level + 1); // 继续往下找
    } else if (first.bus_types) {
      this.totalList(first.bus_types, level + 1, 0);
    }
  }

  totalList(data: any, i: number, j: number) {
    // 如果切换了上层，后面的层级要重新初始化
    if (i < this.displays.length) {
      this.initSelect(data, i);
    }
    // 清空 i 之后的层级选中状态
    Object.keys(this.selectedIndices).forEach((key: any) => {
      if (Number(key) >= i) {
        this.selectedIndices[key] = 0;
      }
    });

    if (!data || data.length === 0) return;

    // 记录本层的选中下标
    this.selectedIndices[i - 1] = j;

    // 如果是最后一层 返回选中
    if ('id' in data[0]) {
      this.selected = data[0];
      return;
    }

    this.displays[i] = data;
  }

  // 标记是否选中
  isSelected(i: number, j: number): boolean {
    return this.selectedIndices[i] === j;
  }

  async find(platform_id: number) {
    try {
      this.loading = true;
      const r = await this.productApi.findBusTypesByPlatformNew(platform_id);
      this.displays = [r.data.tree_view];
      this.initSelect(this.displays[0], 0);
      this.display_label = r.data.all_groups;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
